import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";


function Slider() {
  return (
    <>
      <section className="slider-four">
        <Swiper
          
          loop={true}
          className="swiper-container"
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <div className="slider-four__item">
              <div
                className="slider-four__image"
                style={{
                  backgroundImage: "url(assets/images/shapes/slider-4-bg-1-1.jpg)",
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-xl-5 d-flex">
                    <div className="my-auto">
                      <h2 className="slider-four__title">
                        Let’s Grow your <span>future</span> together
                      </h2>
                      <p className="slider-four__text">
                        Sed ut perspiciatis unde omnis natus sit accusantium
                        doloremque laudantium totam aperiam
                      </p>
                      <div className="slider-four__btns">
                        <Link to="/about" className="thm-btn slider-four__btn">
                          <span>
                            Get Started
                            <i className="far fa-arrow-right" />
                          </span>
                        </Link>
                        <Link
                          to="/about"
                          className="thm-btn thm-btn--three slider-four__btn slider-four__btn--two"
                        >
                          <span>
                            Learn More
                            <i className="far fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-7">
                    <div className="slider-four__main__image">
                      <img src="assets/images/background/slider-4-1.jpg" alt="Slide 1" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <div className="slider-four__item">
              <div
                className="slider-four__image"
                style={{
                  backgroundImage: "url(assets/images/shapes/slider-4-bg-1-1.jpg)",
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-xl-5 d-flex">
                    <div className="my-auto">
                      <h2 className="slider-four__title">
                        Let’s Grow your <span>future</span> together
                      </h2>
                      <p className="slider-four__text">
                        Sed ut perspiciatis unde omnis natus sit accusantium
                        doloremque laudantium totam aperiam
                      </p>
                      <div className="slider-four__btns">
                        <Link to="/about" className="thm-btn slider-four__btn">
                          <span>
                            Get Started
                            <i className="far fa-arrow-right" />
                          </span>
                        </Link>
                        <Link
                          to="/about"
                          className="thm-btn thm-btn--three slider-four__btn slider-four__btn--two"
                        >
                          <span>
                            Learn More
                            <i className="far fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-7">
                    <div className="slider-four__main__image">
                      <img src="assets/images/background/slider-4-2.jpg" alt="Slide 2" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
            <div className="slider-four__item">
              <div
                className="slider-four__image"
                style={{
                  backgroundImage: "url(assets/images/shapes/slider-4-bg-1-1.jpg)",
                }}
              />
              <div className="container">
                <div className="row">
                  <div className="col-xl-5 d-flex">
                    <div className="my-auto">
                      <h2 className="slider-four__title">
                        Let’s Grow your <span>future</span> together
                      </h2>
                      <p className="slider-four__text">
                        Sed ut perspiciatis unde omnis natus sit accusantium
                        doloremque laudantium totam aperiam
                      </p>
                      <div className="slider-four__btns">
                        <Link to="/about" className="thm-btn slider-four__btn">
                          <span>
                            Get Started
                            <i className="far fa-arrow-right" />
                          </span>
                        </Link>
                        <Link
                          to="/about"
                          className="thm-btn thm-btn--three slider-four__btn slider-four__btn--two"
                        >
                          <span>
                            Learn More
                            <i className="far fa-arrow-right" />
                          </span>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-7">
                    <div className="slider-four__main__image">
                      <img src="assets/images/background/slider-4-3.jpg" alt="Slide 3" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>
    </>
  );
}

export default Slider;
